import styled from "styled-components";

export const LicenseTextLinkBox = styled.span`
    text-decoration: underline;
    color: ${props => props.theme.colors.textLight};
    font-size: 1.5rem;
    cursor: pointer;
`